import React from 'react';
import './edit.scss';

interface EditIconProps {
  editValue: number;
}

const EditIcon: React.FC<EditIconProps> = ({ editValue }) => {
  const getIconClass = () => {
    switch (editValue) {
      case 0:
        return 'pi pi-eye'; // View Icon
      case 4:
        return 'pi pi-comments'; // Conversation Icon
      case 3:
        return 'pi pi-plus'; // Add Icon
      case 2:
        return 'pi pi-pencil'; // Edit Icon
      case 1:
        return 'pi pi-trash'; // Deactivate Icon
      default:
        return 'pi pi-question'; // Unknown Action
    }
  };

  const getAriaLabel = () => {
    switch (editValue) {
      case 0:
        return 'View';
      case 4:
        return 'Conversation';
      case 3:
        return 'Add';
      case 2:
        return 'Edit';
      case 1:
        return 'Deactivate';
      default:
        return 'Unknown Action';
    }
  };

  return (
    <i
      className={`edit-action-icon ${getIconClass()}`}
      role="button"
      tabIndex={0}
      aria-label={getAriaLabel()}
    ></i>
  );
};

export default EditIcon;
